export default __webpack_public_path__ + "static/media/Body.7fed0364.svg";